export default __webpack_public_path__ + "static/media/480_portfolio04-it-web.ec88f6d2.png";